import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Home } from "lucide-react";
import { useLocation } from "wouter";

export default function NotFound() {
  const [, setLocation] = useLocation();

  const handleGoHome = () => {
    setLocation("/");
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <Card className="w-full max-w-lg mx-4 shadow-lg border-0 bg-white/80 backdrop-blur-sm">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-[oklch(0.92_0.005_240)] rounded-full animate-pulse" />
              <AlertCircle className="relative h-16 w-16 text-[oklch(0.08_0.01_240)]" />
            </div>
          </div>

          <h1 className="text-4xl font-bold text-[oklch(0.08_0.01_240)] mb-2">404</h1>

          <h2 className="text-xl font-semibold text-[oklch(0.08_0.01_240)] mb-4">
            Page Not Found
          </h2>

          <p className="text-[oklch(0.08_0.01_240)] mb-8 leading-relaxed">
            Sorry, the page you are looking for doesn't exist.
            <br />
            It may have been moved or deleted.
          </p>

          <div
            id="not-found-button-group"
            className="flex flex-col sm:flex-row gap-3 justify-center"
          >
            <Button
              onClick={handleGoHome}
              className="bg-[oklch(0.92_0.005_240)] hover:bg-[oklch(0.12_0.01_240)] text-[oklch(0.18_0.04_240)] px-6 py-2.5 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"
            >
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
